import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  InputLabel,
  TextareaAutosize,
  Typography,
  withStyles,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { requestBlock, requestUnblock } from "../../../../API/Entity";
import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import styles from "./styles";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../Component/CustomButton";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const BlockUnblockRequest = (props) => {
  const { classes, open, entity, onSubmit, onClose } = props;

  const { id: entityId, blocked } = entity || {};
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(open);
  const [reason, setReason] = useState();
  const [isSubmiting, setIsSubmiting] = useState(false);

  const { showMessage, showErrorMessage } = useContext(ModalDialogContext);

  useEffect(() => {
    setReason(null);
    setIsOpen(open);
  }, [open]);

  const updateReason = (e) => {
    setReason(e.target.value);
  };

  const renderBlockForm = () => {
    return (
      <Grid container direction="row" spacing={4}>
        <Grid item xs={12}>
          <span style={{ paddingLeft: 50 }}>
            <InputLabel className={classes.inputLabel}>
              {t("messages.record.reasonForBlock")}
            </InputLabel>
            <TextareaAutosize
              className={classes.textAreaAuto}
              rowsMax={3}
              aria-label="maximum height"
              style={{ height: 50, width: "100%" }}
              value={reason}
              onChange={updateReason}
            />
          </span>
        </Grid>
      </Grid>
    );
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleSubmit = async () => {
    setIsSubmiting(true);
    const method = blocked ? requestUnblock : requestBlock;
    try {
      await method({
        entityId,
        reason,
      });
      showMessage({ message: t("messages.record.blockRequestSubmitted") });
      if (onSubmit) {
        onSubmit();
      }
    } catch (error) {
      showErrorMessage({ error });
    }
    setIsSubmiting(false);
  };

  return (
    <Dialog
      disableBackdropClick
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      fullWidth={true}
      scroll="paper"
      maxWidth="md"
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography className={classes.panelTitle}>
          {blocked ? t("labels.record.requestToUnBlock") : t("labels.record.requestToBlock")}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>{renderBlockForm()}</DialogContent>
      <DialogActions>
        <CustomButton variant="secondary" isDisabled={isSubmiting} onClick={handleClose}>
          {t("labels.common.cancel")}
        </CustomButton>
        <CustomButton 
          variant="primary" 
          loadingText={t("labels.common.submiting")}
          isLoading={isSubmiting}
          isDisabled={isSubmiting}
          onClick={handleSubmit}
        >
          {t("labels.common.submit")}
        </CustomButton>


      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles, { withTheme: true })(BlockUnblockRequest);
